import React from "react";
import styles from "./Layout.module.scss";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <footer className={styles.wrapper__footer}>
      <ul>
        <li>
          <Link
            className={styles.wrapper__footer__minilogotype}
            to="/"
          >
            <img src="/logoBookTheCitySimple.png" alt="" height="40" />
          </Link>
        </li>

        <Link target="_blank" className={styles.wrapper__footer__links} to="/terms"> Términos y Condiciones</Link>
        <Link target="_blank" className={styles.wrapper__footer__links} to="https://bookthecity.app/aviso-legal/"> Políticas de privacidad</Link>
      </ul>
    </footer>
  );
};

export default Footer;
